import { NavLink, useLocation } from 'react-router'
import { DocumentList } from '../components/DocumentList'
import ButtonBars from '../components/ButtonBars'
import { useEffect, useState } from 'react'
import { Filter } from '../components/Filter'
import AuthContext from '../context/AuthContext'
import useAxiosRequests from '../hooks/useAxiosRequest'
import ExternalRoutes from '../config/ExternalRoutes'
import { useContext } from 'react'
import { useMemo } from 'react'
import { CircularProgress } from '@mui/material'

const groupByMonth = docs => {
  return docs.reduce((acc, doc) => {
    const date = new Date(doc.docDateUpload)
    const key = date.toLocaleDateString('fr-FR', {
      year: 'numeric',
      month: 'long'
    })
    if (!acc[key]) acc[key] = []
    acc[key].push(doc)
    return acc
  }, {})
}


const capitalizeFirst = str => str.charAt(0).toUpperCase() + str.slice(1)

export const ChestDocument = () => {
  const [show, setShow] = useState(false)
  const handleShow = () => setShow(true)
  const { userInfo } = useContext(AuthContext)
  const { sendRequest } = useAxiosRequests()
  const [documents, SetDocument] = useState([])
  const { state } = useLocation();
  const { startDate, endDate, docType, status } = state || {};
  const [loading, setLoading] = useState(true);



  const fetchData = async () => {
    try {
      const response = await sendRequest({
        method: 'GET',
        url: ExternalRoutes.document.list_by_user + userInfo.id,
        config: {
          params: {
            'docDateUpload[after]': startDate,
            'docDateUpload[before]': endDate,
            'docType': docType,
            'conDocumentStatus.docStName': status
          }
        }
      })
      if (response) {
        SetDocument(response.member)
      }

    } catch (error) {
    } finally {
      setLoading(false);
    }

  }

  useEffect(() => {
    fetchData();
    setLoading(true);
  }, [startDate, endDate, docType, status]);


  const groupedDocs = useMemo(() => groupByMonth(documents), [documents])

  return (
    <>
      <section>
        <div className='kl-header-document-document'>
          <div className='kl-header-coffre'>
            <NavLink to='/history' className='kl-coffre-faclock'>
              <svg
                width='24'
                height='24'
                viewBox='0 0 24 24'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z'
                  fill='#292D32'
                />
                <path
                  d='M15.7096 15.93C15.5796 15.93 15.4496 15.9 15.3296 15.82L12.2296 13.97C11.4596 13.51 10.8896 12.5 10.8896 11.61V7.51001C10.8896 7.10001 11.2296 6.76001 11.6396 6.76001C12.0496 6.76001 12.3896 7.10001 12.3896 7.51001V11.61C12.3896 11.97 12.6896 12.5 12.9996 12.68L16.0996 14.53C16.4596 14.74 16.5696 15.2 16.3596 15.56C16.2096 15.8 15.9596 15.93 15.7096 15.93Z'
                  fill='#292D32'
                />
              </svg>
            </NavLink>
            <div className='kl-title-header'>
              <h2>Coffre de docs</h2>
            </div>
            <div className=''>
              <NavLink to='/calendar-filter' className='kl-calendar-filter'>
                <svg
                  width='24'
                  height='24'
                  viewBox='0 0 24 24'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M8 5.75C7.59 5.75 7.25 5.41 7.25 5V2C7.25 1.59 7.59 1.25 8 1.25C8.41 1.25 8.75 1.59 8.75 2V5C8.75 5.41 8.41 5.75 8 5.75Z'
                    fill='#292D32'
                  />
                  <path
                    d='M16 5.75C15.59 5.75 15.25 5.41 15.25 5V2C15.25 1.59 15.59 1.25 16 1.25C16.41 1.25 16.75 1.59 16.75 2V5C16.75 5.41 16.41 5.75 16 5.75Z'
                    fill='#292D32'
                  />
                  <path
                    d='M18.2 22.15C16.02 22.15 14.25 20.38 14.25 18.2C14.25 16.02 16.02 14.25 18.2 14.25C20.38 14.25 22.15 16.02 22.15 18.2C22.15 20.38 20.38 22.15 18.2 22.15ZM18.2 15.75C16.85 15.75 15.75 16.85 15.75 18.2C15.75 19.55 16.85 20.65 18.2 20.65C19.55 20.65 20.65 19.55 20.65 18.2C20.65 16.85 19.55 15.75 18.2 15.75Z'
                    fill='#292D32'
                  />
                  <path
                    d='M21.9995 22.7499C21.8095 22.7499 21.6195 22.6799 21.4695 22.5299L20.4695 21.5299C20.1795 21.2399 20.1795 20.7599 20.4695 20.4699C20.7595 20.1799 21.2395 20.1799 21.5295 20.4699L22.5295 21.4699C22.8195 21.7599 22.8195 22.2399 22.5295 22.5299C22.3795 22.6799 22.1895 22.7499 21.9995 22.7499Z'
                    fill='#292D32'
                  />
                  <path
                    d='M8.5 14.4999C8.37 14.4999 8.24 14.4699 8.12 14.4199C7.99 14.3699 7.87999 14.2999 7.78999 14.2099C7.74999 14.1599 7.7 14.1099 7.67 14.0599C7.63 13.9999 7.6 13.9399 7.58 13.8799C7.55 13.8199 7.53 13.7599 7.52 13.6999C7.51 13.6299 7.5 13.5599 7.5 13.4999C7.5 13.2399 7.60999 12.9799 7.78999 12.7899C7.87999 12.6999 7.99 12.6299 8.12 12.5799C8.48 12.4199 8.93001 12.5099 9.21001 12.7899C9.39001 12.9799 9.5 13.2399 9.5 13.4999C9.5 13.5599 9.49 13.6299 9.48 13.6999C9.47 13.7599 9.45 13.8199 9.42 13.8799C9.4 13.9399 9.37 13.9999 9.33 14.0599C9.29 14.1099 9.25001 14.1599 9.21001 14.2099C9.02001 14.3899 8.76 14.4999 8.5 14.4999Z'
                    fill='#292D32'
                  />
                  <path
                    d='M12 14.4999C11.74 14.4999 11.48 14.3899 11.29 14.2099C11.11 14.0199 11 13.7699 11 13.4999C11 13.3699 11.03 13.2399 11.08 13.1199C11.13 12.9999 11.2 12.89 11.29 12.79C11.66 12.42 12.33 12.42 12.71 12.79C12.89 12.98 13 13.2399 13 13.4999C13 13.5599 12.99 13.63 12.98 13.7C12.97 13.76 12.95 13.8199 12.92 13.8799C12.9 13.9399 12.87 13.9999 12.83 14.0599C12.79 14.1099 12.75 14.1599 12.71 14.2099C12.52 14.3899 12.26 14.4999 12 14.4999Z'
                    fill='#292D32'
                  />
                  <path
                    d='M8.5 17.9999C8.24 17.9999 7.97999 17.8899 7.78999 17.7099C7.60999 17.5199 7.5 17.2599 7.5 16.9999C7.5 16.8699 7.53 16.7399 7.58 16.6199C7.63 16.4899 7.69999 16.38 7.78999 16.29C8.15999 15.92 8.84001 15.92 9.21001 16.29C9.39001 16.48 9.5 16.7399 9.5 16.9999C9.5 17.2599 9.39001 17.5199 9.21001 17.7099C9.02001 17.8899 8.76 17.9999 8.5 17.9999Z'
                    fill='#292D32'
                  />
                  <path
                    d='M20.5 9.83984H3.5C3.09 9.83984 2.75 9.49984 2.75 9.08984C2.75 8.67984 3.09 8.33984 3.5 8.33984H20.5C20.91 8.33984 21.25 8.67984 21.25 9.08984C21.25 9.49984 20.91 9.83984 20.5 9.83984Z'
                    fill='#292D32'
                  />
                  <path
                    d='M13.37 22.75H8C4.35 22.75 2.25 20.65 2.25 17V8.5C2.25 4.85 4.35 2.75 8 2.75H16C19.65 2.75 21.75 4.85 21.75 8.5V13C21.75 13.41 21.41 13.75 21 13.75C20.59 13.75 20.25 13.41 20.25 13V8.5C20.25 5.64 18.86 4.25 16 4.25H8C5.14 4.25 3.75 5.64 3.75 8.5V17C3.75 19.86 5.14 21.25 8 21.25H13.37C13.78 21.25 14.12 21.59 14.12 22C14.12 22.41 13.78 22.75 13.37 22.75Z'
                    fill='#292D32'
                  />
                </svg>
              </NavLink>

              <button className='kl-filter-docs-button' onClick={handleShow}>
                <svg
                  width='24'
                  height='24'
                  viewBox='0 0 24 24'
                  fill='none'
                  xmlns='http://www.w3.org/2000/svg'
                >
                  <path
                    d='M10.9298 22.75C10.4498 22.75 9.96985 22.63 9.52985 22.39C8.63985 21.89 8.1098 21 8.1098 19.99V14.64C8.1098 14.13 7.77979 13.38 7.46979 12.99L3.6698 9.00003C3.0398 8.37003 2.5498 7.27002 2.5498 6.46002V4.14005C2.5498 2.53005 3.76982 1.27002 5.31982 1.27002H18.6598C20.1898 1.27002 21.4298 2.51004 21.4298 4.04004V6.26004C21.4298 7.31004 20.7998 8.52002 20.1998 9.11002C19.9098 9.40002 19.4298 9.40002 19.1398 9.11002C18.8498 8.82002 18.8498 8.34002 19.1398 8.05002C19.5098 7.68002 19.9298 6.85004 19.9298 6.26004V4.04004C19.9298 3.34004 19.3598 2.77002 18.6598 2.77002H5.31982C4.60982 2.77002 4.0498 3.37005 4.0498 4.14005V6.46002C4.0498 6.83002 4.34981 7.56004 4.73981 7.95004L8.58984 12C9.09984 12.63 9.59979 13.69 9.59979 14.64V19.99C9.59979 20.65 10.0498 20.97 10.2498 21.08C10.6798 21.32 11.1898 21.31 11.5898 21.07L12.9898 20.17C13.2798 20 13.5598 19.45 13.5598 19.08C13.5598 18.67 13.8998 18.33 14.3098 18.33C14.7198 18.33 15.0598 18.67 15.0598 19.08C15.0598 19.98 14.4998 21.01 13.7898 21.44L12.3998 22.34C11.9498 22.61 11.4398 22.75 10.9298 22.75Z'
                    fill='#292D32'
                  />
                  <path
                    d='M16.0701 17.2701C13.8901 17.2701 12.1201 15.5001 12.1201 13.3201C12.1201 11.1401 13.8901 9.37012 16.0701 9.37012C18.2501 9.37012 20.0201 11.1401 20.0201 13.3201C20.0201 15.5001 18.2501 17.2701 16.0701 17.2701ZM16.0701 10.8701C14.7201 10.8701 13.6201 11.9701 13.6201 13.3201C13.6201 14.6701 14.7201 15.7701 16.0701 15.7701C17.4201 15.7701 18.5201 14.6701 18.5201 13.3201C18.5201 11.9701 17.4201 10.8701 16.0701 10.8701Z'
                    fill='#292D32'
                  />
                  <path
                    d='M19.8705 17.8701C19.6805 17.8701 19.4905 17.8001 19.3405 17.6501L18.3405 16.6501C18.0505 16.3601 18.0505 15.8801 18.3405 15.5901C18.6305 15.3001 19.1105 15.3001 19.4005 15.5901L20.4005 16.5901C20.6905 16.8801 20.6905 17.3601 20.4005 17.6501C20.2605 17.7901 20.0605 17.8701 19.8705 17.8701Z'
                    fill='#292D32'
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
        <div>
          <section>
            {loading ? (
              <div className='kl-nothing-data'>
                <CircularProgress />
              </div>
            ) : (
              <>
                {
                  documents.length > 0 ? (
                    <div className='kl-list-document-by-month'>
                      {Object.entries(groupedDocs).map(([month, docs], index) => (
                        <div key={index}>
                          <div className='kl-date-docs'>
                            <span>{capitalizeFirst(month)}</span>
                            <div className='kl-total-docs'>
                              <span>{docs.length}</span>
                            </div>
                          </div>
                          <div className='kl-document-list-coffre'>
                            {docs.map((document, key) => (
                              <DocumentList
                                key={document.id}
                                document={document}
                                type={document?.conDocumentStatus?.docStName}
                              />
                            ))}
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className='kl-nothing-data'>
                      Aucun document trouvé.
                    </div>
                  )
                }
              </>
            )}

          </section>
        </div>
        <ButtonBars />
        <Filter show={show} onClose={() => setShow(false)} />
      </section>
    </>
  )
}
